// src/utils/validators.js

export const required = (msg = 'Campo obligatorio') => (val) => {
    return (val !== null && val !== undefined && val !== '') || msg;
};

export const minLength = (min, msg) => (val) => {
    return (!val || val.length >= min) || (msg || `Mínimo ${min} caracteres`);
};

export const isPatente = (msg = 'Formato inválido') => (val) => {
    const regex = /^([A-Z]{2}[0-9]{4}|[A-Z]{4}[0-9]{2})$/i;
    return (!val || regex.test(val.replace(/\s|-/g, ''))) || msg;
};